module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance@2x.288be9a1.png";